// Priority industries shown on the homepage and About page.
export const PRIORITY_INDUSTRIES = [
  "Plumbers",
  "Electricians",
  "HVAC",
  "Pest Control",
  "Roofers",
  "Tree Services",
  "Rubbish Removal",
  "Removalists",
  "Garage Doors",
  "Emergency Glass",
  "Cleaning Services",
  "Builders",
] as const;
